import "../../../styles/flashcards/FlashcardsPage.css"; // Import the CSS file
import { logger } from "../../../utils/logger";
import {
  Box,
  FormControl,
  IconButton,
  InputBase,
  InputLabel,
  MenuItem,
  NativeSelect,
  Paper,
  Select,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import SearchIcon from "@mui/icons-material/Search";
import { getFlashcardList } from "../../../services/DashboardApi.js";
import { useNavigate } from "react-router-dom";
import Loader from "../../atoms/Loader.jsx";
import { use } from "react";
import { set } from "lodash";

const FlashcardsPage = () => {
  const [sortByRecent, setSortByRecent] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortType, setSortType] = useState("Recent");
  const navigate = useNavigate();
  const selectedTopic = useSelector((state) => state.selectedTopic);
  const [flashcardList, setFlashcardList] = useState([]);
  // const [filteredFlashcards, setFilteredFlashcards] = useState([]);
  // const [sortedFlashcards, setSortedFlashcards] = useState([]);
  const selectedMainTab = useSelector((state) => state.mainTab.tab_name);
  const { userId } = useSelector((state) => state.userDetails);
  const [isLoading, setIsLoading] = useState(true);
  const [sortedFlashcards, setSortedFlashcards] = useState([]);
  // var sortedFlashcards = [];

  const searchBarRef = useRef(null);
  useEffect(() => {
    const fetchFlashcardsList = async () => {
      setIsLoading(true);
      try {
        let subject = selectedMainTab;
        subject = subject === "MATH" ? "MATHS" : subject;
        let response = await getFlashcardList(userId, subject);
        logger.log("Flashcard list response: ", response.data);
        setFlashcardList(response?.data || []); // Handle cases where response.data is undefined
        setSortedFlashcards(
          [...response.data].sort((a, b) =>
            sortType === "Recent"
              ? new Date(b.CREATED_AT) - new Date(a.CREATED_AT)
              : a.subTopic.localeCompare(b.subTopic)
          )
        );
        searchBarRef.current.value = "";
        setSortType("Recent");
      } catch (error) {
        logger.log("Error fetching flashcard list: ", error);
      } finally {
        logger.log("Flashcard finally: ", flashcardList);

        setIsLoading(false);
      }
    };

    if (userId && selectedMainTab) fetchFlashcardsList();
  }, [selectedMainTab, userId]);

  useEffect(() => {
    setSortedFlashcards(
      [...flashcardList].sort((a, b) =>
        sortType === "Recent"
          ? new Date(b.CREATED_AT) - new Date(a.CREATED_AT)
          : a.subTopic.localeCompare(b.subTopic)
      )
    );
  }, [flashcardList, sortType]);

  useEffect(() => {
    setSortedFlashcards(
      flashcardList?.filter((card) => {
        const matchesTopic =
          selectedTopic.topicId.toLowerCase() === "all" ||
          card.topicId.toLowerCase() ===
            selectedTopic.topicId.toString().toLowerCase();
        return matchesTopic;
      })
    );
  }, [selectedTopic]);

  logger.log("Flashcard list: ", flashcardList);
  // useEffect(() => {
  //   const filtered = sortedFlashcards?.filter((card) => {
  //     const matchesSearch =
  //       card.topic.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       card.subTopic.toLowerCase().includes(searchTerm.toLowerCase());
  //     const matchesTopic =
  //       selectedTopic.topicId === "ALL" ||
  //       card.topicId === selectedTopic.topicId.toString();
  //     return matchesTopic && matchesSearch;
  //   });
  //   setSortedFlashcards(filtered);
  // }, [searchTerm, selectedTopic]);
  const filtered = (searchTerm) => {
    const filteredList = flashcardList?.filter((card) => {
      const matchesSearch =
        card.topic.toLowerCase().includes(searchTerm.toLowerCase()) ||
        card.subTopic.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesTopic =
        selectedTopic.topicId.toLowerCase() === "all" ||
        card.topicId.toLowerCase() ===
          selectedTopic.topicId.toString().toLowerCase();
      return matchesTopic && matchesSearch;
    });

    return filteredList.sort((a, b) =>
      sortType === "Recent"
        ? new Date(b.CREATED_AT) - new Date(a.CREATED_AT)
        : a.subTopic.localeCompare(b.subTopic)
    );
  };

  // logger.log("Filtered flashcards: ", filteredFlashcards);

  // const sortedFlashcards = React.useMemo(() => {
  //   return [...filteredFlashcards].sort((a, b) =>
  //     sortType === "Recent"
  //       ? new Date(b.CREATED_AT) - new Date(a.CREATED_AT)
  //       : a.topic.localeCompare(b.topic)
  //   );
  // }, [filteredFlashcards, sortType]);

  const handleFlashcardHeaderClickInternal = (
    topicId,
    subtopicId,
    flashcardId
  ) => {
    logger.log("Flashcard Header Clicked flashcadrdId: ", flashcardId);
    let subject = selectedMainTab;
    navigate(
      `/flashcard/${topicId}/${subtopicId}/${subject}/${userId}/${flashcardId}`
    );
  };
  logger.log("Sorted flashcards: ", sortedFlashcards);
  return (
    <div className="flashcards-container">
      {/* Sorting Section */}
      <div class="sort-search-header">
        <FormControl
          sx={{ m: 1, minWidth: 120, display: { xs: "none", sm: "flex" } }}
          size="small"
        >
          <InputLabel id="demo-select-small-label" sx={{ color: "#000	" }}>
            Sort By
          </InputLabel>
          <Select
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={sortType}
            label="Sort By"
            onChange={(e) => setSortType(e.target.value)}
          >
            <MenuItem value={"Recent"}>Recent</MenuItem>
            <MenuItem value={"Topic"}>Topic</MenuItem>
          </Select>
        </FormControl>
        <FormControl
          sx={{
            m: 1,
            minWidth: 100,
            display: { xs: "flex", sm: "none" },
            marginTop: "2rem",
          }}
          size="small"
        >
          <InputLabel id="demo-select-small-label" sx={{ color: "#000	" }}>
            Sort By
          </InputLabel>
          <NativeSelect
            sx={{
              display: { xs: "flex", sm: "none" },
            }}
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={sortType}
            label="Sort By"
            onChange={(e) => setSortType(e.target.value)}
          >
            <option value={"Recent"}>Recent</option>
            <option value={"Topic"}>Topic</option>
          </NativeSelect>
        </FormControl>

        {/* Search Bar */}
        <Paper
          component="form"
          sx={{
            p: "0px 4px",
            display: "flex",
            alignItems: "center",
            width: { xs: "10rem", sm: "15rem" },
            marginTop: {
              xs: "2rem",
              sm: "0rem",
            },
            marginRight: {
              xs: 0,
              sm: "3.8rem",
            },
            borderColor: "#000",
            border: 1,
            borderRadius: "15px",
            marginBottom: "1.25rem",
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Search"
            inputProps={{ "aria-label": "Search Topic or Sub Topic" }}
            inputRef={searchBarRef}
            onChange={(e) => {
              setSortedFlashcards(filtered(e.target.value));
            }}
          />
          <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
            <SearchIcon />
          </IconButton>
        </Paper>
      </div>

      {/* Flashcards */}
      {isLoading ? (
        <Loader />
      ) : (
        <div className="flashcards-list">
          {sortedFlashcards?.length > 0 ? (
            sortedFlashcards?.map((card, index) => (
              <div
                key={index}
                className="flashcard-header"
                onClick={() =>
                  handleFlashcardHeaderClickInternal(
                    card.topicId,
                    card.subtopicId,
                    card.flashcardId
                  )
                }
              >
                <p className="flashcard-meta">
                  {card.noOfFlashcards} Terms | {card.topic}
                </p>
                <h3 className="flashcard-title">{card.subTopic}</h3>
              </div>
            ))
          ) : (
            <p className="no-results">No matching flashcards found.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default FlashcardsPage;
